import React from 'react'
import LinkWrap from '../../LinkWrap'
import PageShell from '../foundations/PageShell'
import FAQGroup from './FAQGroup'

const standardRentalQuestions = [
  {
    question: 'Are there any limitations on delivery and installation times during nights or holidays for your equipment?',
    answer: 'No, we offer a 24-hour delivery service for AV productions. However, for services from 8:00 PM to 8:00 AM, an extra charge will be applied, and you will be able to check it before checking out.'
  },
  {
    question: 'If I only need the equipment for a few hours, do I still need to rent it for more than that?',
    answer: 'Yes, our policy requires a 24-hour minimum rental period for all rental options. The prices displayed in our online catalog are based on this 24-hour minimum.'
  },
  {
    question: 'Do I need to pick up the equipment, or do you provide delivery?',
    answer: 'From an equipment catalog, select "Choose Dates & Rent Online", then choose warehouse pickup or delivery and setup. We ask for the dates and location first so we can select the correct warehouse and show equipment that is actually available.'
  },
  {
    question: 'Why do I need to pay a deposit, and can I get a refund if I cancel?',
    answer: 'The deposit is required to reserve the equipment. You can get a full refund if you change your mind and cancel at least 30 days before the scheduled rental date.'
  }
]

const orlandoLocationQuestion = {
  question: 'Do you have a physical location in Orlando?',
  answer: 'Yes, our Orlando Warehouse is located at 8600 Commodity Cir #152 Orlando FL 32819. We also offer the possibility of shipping inventory from Miami\'s headquarters for a one-time fee, no matter how much equipment you ship. This option works great if you are planning a big event and want to have access all our available inventory.',
  answerContent: <>
    Yes, our <LinkWrap href='/orlando/contact-us'>Orlando Warehouse</LinkWrap> is located at 8600 Commodity Cir #152 Orlando FL 32819. We also offer the possibility of shipping inventory from Miami&apos;s headquarters for a one-time fee, no matter how much equipment you ship. This option works great if you are planning a big event and want to have access all our available inventory.
  </>
}

const RentalFAQV2 = ({
  questions,
  orlando = false,
  title = 'Frequently Asked Questions',
  headingId = 'rental-faq-title',
  eyebrow,
  intro,
  includeStructuredData
}) => {
  const hasPageQuestions = Array.isArray(questions) && questions.length > 0
  const resolvedQuestions = hasPageQuestions
    ? questions
    : orlando
      ? [orlandoLocationQuestion, ...standardRentalQuestions]
      : standardRentalQuestions

  return (
    <PageShell>
      <FAQGroup
        questions={resolvedQuestions}
        title={title}
        headingId={headingId}
        eyebrow={eyebrow ?? null}
        intro={intro ?? null}
        includeStructuredData={includeStructuredData ?? hasPageQuestions}
      />
    </PageShell>
  )
}

export default RentalFAQV2
